import type { ReactNode } from "react";
import { BRAND } from "@presentation/brand";

/** Shell for the public portal: brand bar and optional actions on the right. */
export function PortalLayout({ children, actions }: { children: ReactNode; actions?: ReactNode }) {
  return (
    <>
      <header className="topbar">
        <strong>{BRAND.productName}</strong>
        <nav>{actions}</nav>
      </header>
      <main className="container">{children}</main>
      <footer className="container muted small portal-footer">
        {BRAND.legalName} · {BRAND.website} · {BRAND.email} · {BRAND.phone}
      </footer>
    </>
  );
}
